import {BaseApi} from './BaseApi'

export interface EorNameListResponse {
  id: string
  name: string
}

/**
 * EOR API Service
 * Handles all EOR (Employer of Record) related operations
 */
export class EorApi extends BaseApi {
  /**
   * Get list of EOR names and IDs
   * GET /eor/getEorsNameList
   */
  async getEorsNameList(): Promise<EorNameListResponse[]> {
    try {
      const response = await this.client.get<EorNameListResponse[]>('/eor/getEorsNameList')
      return response.data
    } catch (error: unknown) {
      console.error('Error fetching EOR name list:', error)
      throw error
    }
  }

  /**
   * Get EOR name by ID
   * GET /eor/getEorNameById/:id
   */
  async getEorNameById(id: string): Promise<EorNameListResponse> {
    try {
      const response = await this.client.get<EorNameListResponse>(`/eor/getEorNameById/${id}`)
      return response.data
    } catch (error: unknown) {
      console.error('Error fetching EOR name by ID:', id, error)
      throw error
    }
  }
}

// Export singleton instance
export const eorApi = new EorApi()
